<template>
  <div class="paginated-customer-overview-component">

    <table v-if="hasSignals" class="table">
      <thead>
        <tr>
          <th>Omschrijving</th>
          <th>Notitie</th>
          <th>Datum</th>
          <th v-if="showCustomer">Klant</th>
          <th title="Zichtbaar voor klant">Publiek</th>
          <th></th>
        </tr>
      </thead>
      <tbody :class="{ loading: loadingSignals }">
        <SignalRowComponent
            v-for="signal in currentRequestSignals.data"
            :key="signal.id"
            :signal="signal"
            :show-customer="showCustomer"
            @reload-signals="loadPaginatedSignals(returnPage)"
        />
      </tbody>
    </table>

    <div v-else-if="loadingSignals && !hasSignals" class="panel-body" data-dusk="loading-signals">
      <p>Laden...</p>
    </div>

    <div v-else-if="hasError && !loadingSignals" class="panel-body error" data-dusk="has-error">
      <p>{{ errorMessage }}</p>
    </div>

    <div v-else class="panel-body">
      <p>Klant heeft nog geen signalen.</p>
    </div>

<!--    TODO: Refactor using AntDesign pagination ??? -->
    <div v-if="displayPagination" class="panel-body" style="padding-top: 0;">
      <laravel-pagination
          :data="currentRequestSignals"
          @pagination-change-page="loadPaginatedSignals"
          style="margin: 0;"
          size="small"
      ></laravel-pagination>
    </div>

    <div class="panel-footer">
      Signalen worden automatisch aangemaakt
      en kunnen ingesteld worden op het
      dashboard onder de tab "Signalen".
    </div>

  </div>
</template>

<script>
import signalApi from '~/api/signal';
import SignalRowComponent from "./RowComponent";

const moment = require('moment');

export default {
  name: 'CustomerSignalOverview',
  props: {
    customerId: {
      type: [Number, String],
      required: true,
    },
    showCustomer: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    SignalRowComponent,
  },
  mounted() {
    this.loadPaginatedSignals(1);
  },
  data() {
    return {
      currentRequestSignals: {},
      loadingSignals: true,
      hasError: false,
      errorMessage: 'Er is iets fout gegaan bij het laden van de signalen',
    };
  },
  computed: {
    displayPagination() {
      return typeof this.currentRequestSignals.meta !== "undefined";
    },
    returnPage() {
      let currentPage = this.currentRequestSignals.meta.pagination.current_page || null;
      let dataLength = this.currentRequestSignals.data.length;

      return dataLength < 1 ? currentPage - 1 : currentPage;
    },
    hasSignals() {
      return this.currentRequestSignals.data && this.currentRequestSignals.data.length > 0;
    }
  },
  methods: {
    loadPaginatedSignals(page = 1, perPage = 10) {
      this.loadingSignals = true;
      signalApi.paginateByCustomerFamily(this.customerId, page, perPage,['customer', 'signal_query'])
          .then((response) => {
            this.currentRequestSignals = response;
          })
          .catch((error) => {
            this.hasError = true;
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: this.errorMessage,
            });
          })
          .finally(() => {
            this.loadingSignals = false;
          });
    },
  },
};
</script>

<style scoped>
.loading {
  opacity: .5;
}
</style>
